<template>
  <div class="home-box">
    <v-row>
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="orange"
      ></v-progress-linear>
      <v-col lg="6" md="6" sm="12">
        <v-card v-if="!loading && member">
          <v-card-title dark>
            <v-btn fab small depressed :to="'/'" title="Back">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-spacer></v-spacer>           
          </v-card-title>
          <div class="profile-avatar">
            <v-avatar
              class="profile text-center"
              v-if="member && member.profile_image"
              color="grey"
              size="150"
            >
              <v-img :src="member.profile_image"></v-img>
            </v-avatar>
            <v-avatar
              size="150"
              v-else
              :color="
                getProfileColor(
                  member.display_name ? member.display_name[0] : ''
                )
              "
            >
              <span
                v-if="member && member.display_name"
                class="text-uppercase white--text md-text"
              >
                {{ member.display_name[0] }}{{ member.display_name[1] }}
              </span>
            </v-avatar>
            <v-card-title class="text-capitalize">{{
              member.display_name
            }}</v-card-title>
          </div>

          <v-list>
            <v-divider v-if="member && member.club"></v-divider>
            <v-list-item v-if="member && member.club">
              <v-list-item-action>
                <span style="width:150px;">Lions Club:</span>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ member.club.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider v-if="member"></v-divider>
            <v-list-item>
              <v-list-item-action>
                <span style="width:150px;">Membership Id:</span>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{
                  member.international_id
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider v-if="member"></v-divider>
            <v-list-item>
              <v-list-item-action>
                <span style="width:150px;">Mobile:</span>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{
                  member.mobile
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider v-if="member"></v-divider>
            <v-list-item>
              <v-list-item-action>
                <span style="width:150px;">Member Since:</span>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ member.member_since }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
             <v-divider v-if="member"></v-divider>
            <v-list-item>
              <v-list-item-action>
                <span style="width:150px;">Member Spouse:</span>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ member.spouse }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>

      <v-col lg="6" md="6" sm="12">
        <v-card v-if="!loading">
          <v-card-title dark>
            <span>Office Roles</span>
          </v-card-title>
          <v-divider></v-divider>

          <div v-if="member.office_roles && member.office_roles.length > 0">
            <v-list v-for="x in member.office_roles" :key="x.uuid">
              <v-subheader v-if="x.role">
                <strong>{{ x.role.name }}</strong>
                <v-spacer></v-spacer>
                {{ x.date_from }} to {{ x.date_to }}
              </v-subheader>
            </v-list>
          </div>
          <v-list v-else>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="orange--text"
                  >Roles not fond!</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
        <v-card v-if="!loading" class="mt-5">
          <v-card-title dark>
            <span>Member Contacts</span>
          </v-card-title>
          <v-divider></v-divider>

          <div v-if="member.contacts && member.contacts.length > 0">
            <v-list v-for="y in member.contacts" :key="y.uuid">
              <v-subheader v-if="y.contact && y.type">
                <strong>{{ y.type.name }}</strong>
                <v-spacer></v-spacer>
                {{ y.contact }}
              </v-subheader>
            </v-list>
          </div>
          <v-list v-else>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="orange--text"
                  >Contacts not fond!</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { filters } from "../../utility/filters";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import { MemberService } from "../../services/member-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "MemberInfo",  
  data() {
    return {
      member:[],
      loading:false,
      defaultImage: require("@/assets/img/avatar.svg"),
    };
  },

  computed: {
    ...mapGetters({
      profile: "profile",
    }),
  },

   mounted() {
    this.$store.dispatch("auth/getProfile");
    this.getMemberInfo();
  },


  methods: {
     getMemberInfo() {
      this.loading = true;
      MemberService.getClubMemberInfo(this.$route.params.id)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.member = response.data.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.member = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    getProfileColor(letter) {
      return filters.getProfileColor(letter);
    },
  },
};
</script>
<style>
.profile-avatar {
  text-align: center;
  padding: 5px;
}

.profile-avatar .v-card__title {
  align-items: center;
  display: grid;
  flex-wrap: wrap;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2rem;
  word-break: break-all;
}
</style>
